import { render, staticRenderFns } from "./BbmEdit.vue?vue&type=template&id=3f1263e8&scoped=true"
import script from "./BbmEdit.vue?vue&type=script&lang=js"
export * from "./BbmEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1263e8",
  null
  
)

export default component.exports